/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Use_Seasonal_ContentInputs */

const en_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access Various Trees and Sounds for Free`)
};

const ar_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمتع بالوصول إلى أشجار وأصوات متنوعة مجانًا`)
};

const de_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greifen Sie Kostenlos auf Verschiedene Bäume und Klänge zu`)
};

const es_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accede Gratis a Varios Árboles y Sonidos`)
};

const fr_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accédez Gratuitement à Divers Arbres et Sons`)
};

const it_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi Gratuitamente a Vari Alberi e Suoni`)
};

const ja_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さまざまな樹木とサウンドを無料で利用`)
};

const ko_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다양한 나무와 사운드를 무료로 이용하세요`)
};

const pt_br_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesse Várias Árvores e Sons Gratuitamente`)
};

const ru_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите Доступ к Различным Деревьям и Звукам Бесплатно`)
};

const th_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าถึงต้นไม้และเสียงต่าง ๆ ได้ฟรี`)
};

const tr_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çeşitli Ağaç ve Sese Ücretsiz Erişin`)
};

const zh_cn_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费使用多种树和声音`)
};

const zh_tw_free_use_seasonal_content = /** @type {(inputs: Free_Use_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費使用多種樹和聲音`)
};

/**
* | output |
* | --- |
* | "Access Various Trees and Sounds for Free" |
*
* @param {Free_Use_Seasonal_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const free_use_seasonal_content = /** @type {((inputs?: Free_Use_Seasonal_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Use_Seasonal_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_use_seasonal_content(inputs)
	if (locale === "ar") return ar_free_use_seasonal_content(inputs)
	if (locale === "de") return de_free_use_seasonal_content(inputs)
	if (locale === "es") return es_free_use_seasonal_content(inputs)
	if (locale === "fr") return fr_free_use_seasonal_content(inputs)
	if (locale === "it") return it_free_use_seasonal_content(inputs)
	if (locale === "ja") return ja_free_use_seasonal_content(inputs)
	if (locale === "ko") return ko_free_use_seasonal_content(inputs)
	if (locale === "pt_br") return pt_br_free_use_seasonal_content(inputs)
	if (locale === "ru") return ru_free_use_seasonal_content(inputs)
	if (locale === "th") return th_free_use_seasonal_content(inputs)
	if (locale === "tr") return tr_free_use_seasonal_content(inputs)
	if (locale === "zh_cn") return zh_cn_free_use_seasonal_content(inputs)
	return zh_tw_free_use_seasonal_content(inputs)
});